import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { scenarioKeys } from "../model/keys"

// A proposed scenario, an accepted one, and the seventh that closes the circle:
// three notifications the user answers in the same place, the board with that
// friend. Scenario state itself rides the dedicated `scenario.*` events, so
// these only stale the cache rather than refetching it.
const names = [
	"scenario_offered",
	"scenario_answered",
	"scenario_circle",
] as const

for (const name of names) {
	registerNotification(name, {
		handle: ({ notification_id, data }, ctx) => {
			showNotification({
				type: "silent",
				placement: null,
				origin: "server",
				notificationId: notification_id,
				name,
			})
			ctx.queryClient.invalidateQueries({
				queryKey: scenarioKeys.current(data.friend_id),
				refetchType: "none",
			})
		},
		route: ({ data }) => ({
			to: "/board/friend/$friendId",
			params: { friendId: data.friend_id },
		}),
		routePopup: null,
	})
}
